import serviceName from './serviceName';
import category from './category';
import subscription from './subscription';
import increment from './increment';
import minmax from './minmax';
import syncStatus from './syncStatus';
import denyLinkDuplicates from './denyLinkDuplicates';
import overflow from './overflow';
import startCountParsing from './startCountParsing';
import autoComplete from './autoComplete';
import refill from './refill';
import ignoreCompletedStatusFromProvider from './ignoreCompletedStatusFromProvider';

export default {
  serviceName,
  category,
  subscription,
  increment,
  minmax,
  syncStatus,
  denyLinkDuplicates,
  overflow,
  startCountParsing,
  autoComplete,
  refill,
  ignoreCompletedStatusFromProvider,
}
